// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"61043a36","321":"1c6928c9","358":"a1656854","648":"a87939f4","794":"7418fa2a","828":"f0478455","853":"32be769e","888":"d207a312"}[chunkId] + ".chunk.js";
};